import { API_AUTH } from "./common";

const CongNoThanhLyApi = {
  list: ({ customerName, pageIndex, pageSize }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-cong-no-thanh-ly?customerName=${customerName}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  list1: ({
    customerName,
    taisanCode,
    hopdongCode,
    tuNgay,
    denNgay,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-cong-no-thanh-ly-1?customerName=${customerName}&taisanCode=${taisanCode}&hopdongCode=${hopdongCode}&tuNgay=${tuNgay}&denNgay=${denNgay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  xoaCongNoThanhLy: (thanhlyId) => {
    return API_AUTH.post(
      `quan-ly-tai-san/xoa-cong-no-thanh-ly?thanhlyId=${thanhlyId}`,
      {}
    );
  },

  thanhToan: (ThanhLyId, NgayThanhLy, TienThanhLy, GhiChu) => {
    return API_AUTH.post(`quan-ly-tai-san/thanh-toan-cong-no-thanh-ly`, {
      ThanhLyId,
      NgayThanhLy,
      TienThanhLy,
      GhiChu,
    });
  },

  getInThu: (thuId) => {
    return API_AUTH.get(
      `quan-ly-tai-san/in-chi-tiet-phieu-thu-cong-no-thanh-ly?thuId=${thuId}`,
      {}
    );
  },

  getInThuChi1: (thuId) =>
    API_AUTH.get(
      `quan-ly-tai-san/in-chi-tiet-phieu-thu-cong-no-thanh-ly?thuId=${thuId}`,
      {}
    ),
};

export default CongNoThanhLyApi;
